export default "__VITE_ASSET__McvlYr3___"